/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState, useMemo, useContext } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import { BiDetail } from "react-icons/bi";
import FormSelect from "ui/select";
import { FormDropdown } from "ui/combo-box";
import {
  useGetEmployees,
  useGetEmployeeDetails,
  useGetFieldTeam,
  useGetUserByRoles,
} from "services/auth";
import { PATHS } from "routes/paths";
import FormInput from "ui/Input";
import { useGetTaskDetails, useUpdateTask } from "services/tickets";
import { BreadCrumb } from "ui/bread-crumbs";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import {
  useAddNotes,
  useAssignFieldTeam,
  useGetRequestDetails,
  useSelfAssign,
} from "services/maintenance";
import { useGetLocationDetails } from "services/service-points";
import { useUser } from "hooks/use-user";
import { useGetRouteDetails } from "services/routes";
import { useLookupAllRoute } from "services/lookups";
import ResolutionNotes from "components/tickets/resolution-notes";
import sweetAlert from "components/sweet-alert";
import { StatusContext, TOGGLE } from "../constants";
import UserDetails from "../common/user-details";
import TicketsByLocation from "../common/tickets-by-location";
import LocationDetails from "../common/location-details";
import RouteDetails from "../common/route-details";
import {
  disableTaskEditing,
  getParentTicketList,
  isCallCenterAgent,
} from "../utils";

export default function TaskDetails() {
  const [taskDetails, setTaskDetails] = useState({});
  const navigate = useNavigate();
  const params = useParams();
  const { status } = useContext(StatusContext);
  const user = useUser();
  const isCCA = isCallCenterAgent(user);

  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: loadingDetails,
    error: detailsError,
    reset: resetDetails,
  } = isCCA ? useGetTaskDetails() : useGetRequestDetails();
  const {
    mutate: getRoutes,
    data: getRoutesRes,
    isPending: loadingRoutes,
  } = useLookupAllRoute();
  const {
    mutate: getFieldTeam,
    data: fieldTeamList,
    isPending: gettingFieldTeam,
  } = useGetFieldTeam();
  const {
    mutate: getEmployee,
    data: getEmployeeRes,
    isPending: gettingDesignations,
  } = useGetEmployees();
  const {
    mutate: getSuperVisor,
    data: supervisorList,
    isPending: gettingSupervisor,
  } = useGetUserByRoles();

  const {
    mutate: updateTask,
    data: updateTaskDetailsRes,
    isPending: updatingTask,
    error: updateTaskError,
    reset: resetTaskUpdate,
  } = useUpdateTask();

  const {
    mutate: addTaskNotes,
    data: addingNotesRes,
    isPending: addingNotes,
    reset: resetAddNotes,
  } = useAddNotes();

  const {
    mutate: assignFieldTeam,
    data: assignTeamRes,
    isPending: assigningTeam,
    error: assignTeamError,
    reset: resetAssignTeam,
  } = useAssignFieldTeam();
  const {
    mutate: assignSelf,
    data: assignSelfRes,
    isPending: assigningSelf,
    error: assignSelfError,
    reset: resetAssignSelf,
  } = useSelfAssign();

  const {
    mutate: getAssetDetails,
    data: assetDetailsRes,
    error: assetDetailsError,
  } = useGetLocationDetails();
  const {
    mutate: getUserDetails,
    data: userDetailsRes,
    error: userDetailsError,
  } = useGetEmployeeDetails();
  const {
    mutate: getSecondaryAssigneeDetails,
    data: secondaryAssigneeDetailsRes,
    error: secondaryAssigneeDetailsError,
  } = useGetEmployeeDetails();
  const {
    mutate: getSupervisorDetails,
    data: supervisorDetailsRes,
    error: supervisorDetailsError,
  } = useGetEmployeeDetails();
  const {
    mutate: getRouteDetails,
    data: routeDetailsRes,
    error: routeDetailsError,
  } = useGetRouteDetails();
  const getHomeURL = getParentTicketList(status);
  const form = useForm();
  const generalProps = { errors: form.formState.errors, control: form.control };
  useEffect(() => {
    if (detailsRes) {
      form.reset({
        ...detailsRes.data,
        vaultAccessAdded: detailsRes.data.vaultAccessAdded ? "Yes" : "No",
        vaultAccessRequired: detailsRes.data.vaultAccessRequired ? "Yes" : "No",
        replenishmentRequired: detailsRes.data.replenishmentRequired
          ? "Yes"
          : "No",
        updatedRemarks: "",
      });

      if (detailsRes.data.assignmentGroup === "SLM-Gunnebo") {
        getEmployee("SLM Engineer");
      }
      setTaskDetails({ ...detailsRes.data });

      getAssetDetails(detailsRes.data.servicePointId);
      if (detailsRes.data.assigneeId) {
        getUserDetails(detailsRes.data.assigneeId);
      }
      if (detailsRes.data.secondaryAssigneeId) {
        getSecondaryAssigneeDetails(detailsRes.data.secondaryAssigneeId);
      }
      if (detailsRes.data.dispatcherId) {
        getSupervisorDetails(detailsRes.data.dispatcherId);
      }
      if (detailsRes.data.routeNo) {
        getRouteDetails(detailsRes.data.routeNo);
      }
      resetDetails();
    }
    if (updateTaskError) {
      resetTaskUpdate();
    }
    if (updateTaskDetailsRes) {
      // resetTaskUpdate();
      // getDetails(params.requestId);

      navigate(getHomeURL);
    }
    if (assignTeamRes) {
      resetAssignTeam();
      getDetails(params.requestId);
      navigate(getHomeURL);
    }

    if (assignTeamError) {
      resetAssignTeam();
    }
    if (assignSelfRes) {
      resetAssignSelf();
      getDetails(params.requestId);
      navigate(getHomeURL);
    }
    if (assignSelfError) {
      resetAssignSelf();
    }
    if (addingNotesRes) {
      resetAddNotes();
      form.setValue("notesRemarks", "");
      form.setValue("notesAdditionalRemarks", "");
      getDetails(params.requestId);
    }
  }, [
    detailsError,
    detailsRes,
    updateTaskDetailsRes,
    updateTaskError,
    assignTeamRes,
    assignTeamError,
    assignSelfRes,
    assignSelfError,
    addingNotesRes,
  ]);
  useEffect(() => {
    if (params.requestId) {
      getDetails(params.requestId);
      if (!isCCA) {
        getSuperVisor(["Call Out Dispatcher"]);
        getRoutes();
        getFieldTeam();
      }
    }
  }, []);

  const onUpdate = () => {
    const _data = form.getValues();
    const payload = {
      requestId: _data.requestId,
      vaultAccessAdded: _data.vaultAccessAdded === "Yes",
      remarks: _data.updatedRemarks || "",
    };
    updateTask(payload);
  };

  const onSelfAssign = () => {
    assignSelf(form.getValues("requestId"));
  };

  const onAssignTeam = () => {
    const data = form.getValues();

    if (taskDetails.assigneeId !== data.assigneeId) {
      sweetAlert({
        title: "Warning",
        text: "Are you sure you want to update team",
        icon: "icon",
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",

        onCancel: () => {},
        onConfirm: () => {
          const payload = {
            requestId: data.requestId,
            routeNo: data.routeNo || "",
            assigneeId: data.assigneeId || "",
            secondaryAssigneeId: data.secondaryAssigneeId || "",
            remarks: data.updatedRemarks || "",
            dispatcherId: data.dispatcherId || "",
          };
          assignFieldTeam(payload);
        },
      });
    } else if (
      taskDetails.routeNo !== data.routeNo ||
      taskDetails.secondaryAssigneeId !== data.secondaryAssigneeId ||
      taskDetails.updatedRemarks !== data.updatedRemarks ||
      taskDetails.dispatcherId !== data.dispatcherId
    ) {
      const payload = {
        requestId: data.requestId,
        routeNo: data.routeNo || "",
        assigneeId: data.assigneeId || "",
        secondaryAssigneeId: data.secondaryAssigneeId || "",
        remarks: data.updatedRemarks || "",
        dispatcherId: data.dispatcherId || "",
      };
      assignFieldTeam(payload);
    } else {
      sweetAlert({
        title: "Warning",
        text: "Nothing to update",
        icon: "icon",
      });
    }
  };

  const onReset = () => {
    form.reset({
      ...taskDetails,
      updatedRemarks: "",
    });
  };

  const addNotes = () => {
    const payload = {
      remarks: form.getValues("notesRemarks"),
      additionalRemarks: form.getValues("notesAdditionalRemarks"),
      requestId: form.getValues("requestId"),
    };
    addTaskNotes(payload);
  };

  const onCancel = () => {
    navigate(getHomeURL);
  };

  const isFormDisabled = useMemo(() => {
    const status = form.watch("status");
    return disableTaskEditing(status);
  }, [form.watch("status")]);

  const isRouteDisabled = useMemo(() => {
    return (
      form.watch("vaultAccessAdded") === "Yes" ||
      taskDetails.assignmentGroup === "SLM-Gunnebo" ||
      isFormDisabled
    );
  }, [taskDetails, form.watch("vaultAccessAdded"), isFormDisabled]);

  const isAssigneeDisabled = useMemo(() => {
    return form.watch("vaultAccessAdded") === "Yes" || isFormDisabled;
  }, [form.watch("vaultAccessAdded"), isFormDisabled]);

  const isSecondaryAssigneeRequired = useMemo(() => {
    return (
      taskDetails.vaultAccessRequired &&
      taskDetails.assignmentGroup !== "SLM-Gunnebo"
    );
  }, [taskDetails]);

  const fieldTeam = useMemo(() => {
    if (
      taskDetails?.assignmentGroup &&
      taskDetails.assignmentGroup === "SLM-Gunnebo"
    ) {
      return getEmployeeRes?.data || [];
    }
    if (fieldTeamList) {
      return fieldTeamList?.data?.map((elm) => ({
        ...elm,
        name: `${elm.employeeId}-${elm.name} (${elm.nationality})`,
      }));
    }

    return [];
  }, [taskDetails, getEmployeeRes, fieldTeamList]);

  const onRouteChange = (data) => {
    // form.setValue("assigneeId", "");
    // form.setValue("secondaryAssigneeId", "");
    getRouteDetails(data);
  };
  const onAssigneeChange = (data) => {
    form.clearErrors(["assigneeId", "secondaryAssigneeId"]);
    getUserDetails(data);
    const employee = fieldTeam.find((elm) => elm.employeeId === data);
    if (employee) {
      form.setValue(
        "assigneeCenconId",
        employee.cenconId ? employee.cenconId : ""
      );
    }
  };
  const onSecondaryAssigneeChange = (data) => {
    getSecondaryAssigneeDetails(data);
    form.clearErrors(["assigneeId", "secondaryAssigneeId"]);
    const employee = fieldTeam.find((elm) => elm.employeeId === data);
    if (employee) {
      form.setValue(
        "secondaryAssigneeCenconId",
        employee.cenconId ? employee.cenconId : ""
      );
    }
  };
  const onSupervisorChange = (data) => {
    getSupervisorDetails(data);
  };

  function AssetDetails() {
    if (assetDetailsError && assetDetailsError.status === 403) {
      return <>User is not authorized to view data</>;
    }
    if (!form.watch("servicePointId") || !assetDetailsRes) {
      return <>Select Asset To Show Data</>;
    }

    return <LocationDetails location={assetDetailsRes.data} />;
  }
  function AccountRecords() {
    if (!form.watch("servicePointId")) {
      return <>Select Asset To Show Data</>;
    }

    return <TicketsByLocation servicePointId={form.watch("servicePointId")} />;
  }
  function EmployeeDetails() {
    if (userDetailsError && userDetailsError.status === 403) {
      return <>User Is Not Authorized TO View Data</>;
    }
    if (!form.watch("assigneeId") || !userDetailsRes) {
      return <>Assignee Not Assigned</>;
    }

    return <UserDetails user={userDetailsRes.data} />;
  }
  function SecondaryAssigneeDetails() {
    if (
      secondaryAssigneeDetailsError &&
      secondaryAssigneeDetailsError.status === 403
    ) {
      return <>User Is Not Authorized TO View Data</>;
    }
    if (!form.watch("secondaryAssigneeId") || !secondaryAssigneeDetailsRes) {
      return <>Secondary Assignee Not Assigned</>;
    }

    return <UserDetails user={secondaryAssigneeDetailsRes.data} />;
  }
  function SupervisorDetails() {
    if (supervisorDetailsError && supervisorDetailsError.status === 403) {
      return <>User Is Not Authorized TO View Data</>;
    }
    if (!form.watch("dispatcherId") || !supervisorDetailsRes) {
      return <>Supervisor Not Assigned</>;
    }

    return <UserDetails user={supervisorDetailsRes.data} />;
  }
  function RouteDetail() {
    if (routeDetailsError && routeDetailsError.status === 403) {
      return <>User Is Not Authorized TO View Data</>;
    }
    if (!form.watch("routeNo") || !routeDetailsRes) {
      return <>Route Not Assigned</>;
    }

    return <RouteDetails route={routeDetailsRes.data} />;
  }

  return (
    <>
      {loadingDetails ||
      updatingTask ||
      addingNotes ||
      assigningTeam ||
      gettingFieldTeam ||
      gettingDesignations ||
      assigningSelf ||
      gettingSupervisor ||
      loadingRoutes ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          items={[
            { to: getHomeURL, text: `Tickets` },

            {
              to: `${PATHS.ticketDetails}/${taskDetails.ticketId}`,
              text: taskDetails.caseNo || "Parent",
            },
            {
              text: `Task Details`,
            },
          ]}
        />
        <div className="flex flex-row justify-end w-full gap-2 items-center">
          <Link to={`${PATHS.jobCards}/${form.watch("requestId")}`}>
            {/* <Button>Ticket Details</Button> */}
            <Button
              variant="outline"
              className="border-secondary"
              title="View Job Card"
            >
              <BiDetail
                className="text-secondary cursor-pointer"
                fontSize="20px"
              />
            </Button>
          </Link>

          <Button
            variant="secondary"
            disabled={isFormDisabled}
            onClick={isCCA ? onUpdate : form.handleSubmit(onAssignTeam)}
          >
            Update
          </Button>
          {!isCCA ? (
            <Button
              variant="secondary"
              disabled={isFormDisabled}
              onClick={onSelfAssign}
            >
              Self Assign
            </Button>
          ) : (
            <></>
          )}

          <Button
            variant="secondary"
            disabled={isFormDisabled}
            onClick={onReset}
          >
            Reset
          </Button>

          <Button variant="secondary" onClick={onCancel}>
            Home
          </Button>
        </div>
        {/* <div className="flex flex-row justify-end w-full gap-2"></div> */}
        <Card className="form-card  shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Task Details</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form className="space-y-8 custom-form-v2">
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormInput
                    {...generalProps}
                    name="taskNo"
                    label="Task Number"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="status"
                    label="State"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="caseNo"
                    label="Parent"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="state"
                    label="Region"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="customer"
                    label="Account"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="locationName"
                    label="Location Name"
                    disabled
                  />

                  <FormInput
                    {...generalProps}
                    name="locationId"
                    label="Asset Id"
                    disabled
                    detailsView={<AssetDetails />}
                    recordsView={<AccountRecords />}
                    recordContentClass="max-w-[1000px]"
                  />
                  {isCCA ? (
                    <FormInput
                      {...generalProps}
                      name="routeNo"
                      label="Route"
                      disabled
                      detailsView={<RouteDetail />}
                    />
                  ) : (
                    <FormDropdown
                      {...generalProps}
                      label="Route"
                      name="routeNo"
                      isRequired={isRouteDisabled}
                      disabled={isRouteDisabled}
                      placeholder="Select Routes"
                      data={getRoutesRes?.data || []}
                      text="routeNo"
                      id="routeNo"
                      detailsView={<RouteDetail />}
                      onChange={onRouteChange}
                      // rules={
                      //   isRouteDisabled
                      //     ? {}
                      //     : { required: "Please Select Route" }
                      // }
                    />
                  )}

                  <FormInput
                    {...generalProps}
                    name="serviceType"
                    label="Activity Type"
                    disabled
                  />

                  {isCCA ? (
                    <FormInput
                      {...generalProps}
                      name="assigneeId"
                      label="Primary Assignee"
                      detailsView={<EmployeeDetails />}
                      disabled
                    />
                  ) : (
                    <FormDropdown
                      {...generalProps}
                      label="Primary Assignee"
                      name="assigneeId"
                      placeholder="Select Assignee"
                      isRequired
                      rules={{
                        required: "Please Select Assignee",
                        validate: (value) => {
                          if (
                            value &&
                            value === form.watch("secondaryAssigneeId")
                          )
                            return "Assignee Can Not Be Same As Secondary Assignee";
                          return true;
                        },
                      }}
                      detailsView={<EmployeeDetails />}
                      onChange={onAssigneeChange}
                      disabled={isAssigneeDisabled}
                      data={fieldTeam}
                      text="name"
                      id="employeeId"
                    />
                  )}

                  <FormInput
                    {...generalProps}
                    name="fault"
                    label="Category"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="assigneeCenconId"
                    label="Cencon Id"
                    disabled
                  />

                  <FormInput
                    {...generalProps}
                    name="faultDetails"
                    label="Sub Category"
                    disabled
                  />
                  {isCCA ? (
                    <FormInput
                      {...generalProps}
                      name="secondaryAssigneeId"
                      label="Secondary Assignee"
                      detailsView={<SecondaryAssigneeDetails />}
                      disabled
                    />
                  ) : (
                    <FormDropdown
                      {...generalProps}
                      label="Secondary Assignee"
                      name="secondaryAssigneeId"
                      isRequired={isSecondaryAssigneeRequired}
                      rules={
                        isSecondaryAssigneeRequired
                          ? {
                              // required: "Please Select Assignee",
                              validate: (value) => {
                                if (value && value === form.watch("assigneeId"))
                                  return "Secondary Assignee Can Not Be Same As Assignee";
                                return true;
                              },
                            }
                          : {
                              validate: (value) => {
                                if (value && value === form.watch("assigneeId"))
                                  return "Secondary Assignee Can Not Be Same As Assignee";
                                return true;
                              },
                            }
                      }
                      disabled={isAssigneeDisabled}
                      onChange={onSecondaryAssigneeChange}
                      detailsView={<SecondaryAssigneeDetails />}
                      placeholder="Select Secondary Assignee"
                      data={fieldTeam}
                      text="name"
                      id="employeeId"
                    />
                  )}
                  <FormInput
                    {...generalProps}
                    name="vaultAccessRequired"
                    label="Vault Access Required"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="secondaryAssigneeCenconId"
                    label="Cencon Id"
                    disabled
                  />
                  <FormSelect
                    {...generalProps}
                    name="vaultAccessAdded"
                    label="Vault Access Added"
                    placeholder="Select Vault Access"
                    disabled={isFormDisabled}
                    data={TOGGLE}
                    id="text"
                    text="text"
                  />
                  {isCCA ? (
                    <FormInput
                      {...generalProps}
                      name="dispatcherName"
                      label="Supervisor"
                      detailsView={<SupervisorDetails />}
                      disabled
                    />
                  ) : (
                    <FormDropdown
                      {...generalProps}
                      name="dispatcherId"
                      label="Supervisor"
                      data={supervisorList?.data || []}
                      id="employeeId"
                      text="name"
                      placeholder="Select Supervisor"
                      detailsView={<SupervisorDetails />}
                      onChange={onSupervisorChange}
                      disabled={isFormDisabled}
                    />
                  )}

                  <FormInput
                    {...generalProps}
                    name="replenishmentRequired"
                    label="Replenishment Required"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    name="reasons"
                    label="Reason"
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="correlationId"
                    label="Correlation Id"
                    disabled
                  />
                </div>

                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="updatedRemarks"
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full mt-6">
                          <Label
                            label="Remarks"
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                disabled={
                                  (!isCCA &&
                                    form.watch("vaultAccessAdded") === "Yes") ||
                                  isFormDisabled
                                }
                                style={
                                  form.formState?.errors?.updatedRemarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.updatedRemarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.updatedRemarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>

                <Tabs
                  defaultValue="notes"
                  className="w-full form-container-tabs"
                  variant="secondary"
                >
                  <TabsList
                    className="w-full justify-start"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TabsTrigger value="notes">Notes</TabsTrigger>
                    <TabsTrigger value="resolutionNotes" disabled={isCCA}>
                      Resolution Notes
                    </TabsTrigger>
                    <TabsTrigger value="denominations">
                      Denominations
                    </TabsTrigger>
                  </TabsList>

                  <TabsContent value="notes">
                    {form.watch("status") !== "Closed" &&
                    form.watch("status") !== "Cancelled" ? (
                      <>
                        <FormField
                          control={form.control}
                          name="notesRemarks"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Work Notes" />

                              <FormControl>
                                <Textarea
                                  {...field}
                                  className="border-secondary"
                                  style={{ marginBottom: "16px" }}
                                />
                              </FormControl>
                            </FormItem>
                          )}
                        />
                        <FormField
                          control={form.control}
                          name="notesAdditionalRemarks"
                          render={({ field }) => (
                            <FormItem>
                              <Label label="Additional Comments" />
                              <FormControl>
                                <Textarea
                                  {...field}
                                  className="border-secondary mb-4"
                                  style={{ marginBottom: "16px" }}
                                />
                              </FormControl>
                            </FormItem>
                          )}
                        />

                        <div className="flex flex-row w-full justify-end">
                          <Button variant="secondary" onClick={addNotes}>
                            Post
                          </Button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {form.watch("logs")?.map((elm, index) => {
                      return (
                        <Card
                          className=" px-2 py-4 my-2 shadow-none rounded-lg  justify-between flex flex-row gap-8"
                          key={`${index}-${elm.operation}`}
                        >
                          <div className="flex flex-col gap-2 max-w-[70%]">
                            <p className="font-medium text-md">
                              Action: {elm.operation}
                            </p>

                            <p className="font-normal text-md">
                              <span className="font-medium"> Notes: </span>
                              {elm.remarks}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium">Comments: </span>
                              {elm.additionalRemarks}
                            </p>
                          </div>
                          <div className="flex flex-col gap-2">
                            <p className="font-normal text-md">
                              <span className="font-medium">Updated By:</span>
                              &nbsp;
                              {elm.user}
                            </p>
                            <p className="font-normal text-md">
                              <span className="font-medium"> Updated At: </span>
                              {elm.operationTime}
                            </p>
                          </div>
                        </Card>
                      );
                    })}
                  </TabsContent>
                  <TabsContent value="resolutionNotes">
                    <ResolutionNotes requestId={taskDetails.requestId} />
                  </TabsContent>
                  <TabsContent value="denominations">
                    <table width="100%" className="job-card text-sm">
                      <col width="50%" />
                      <col width="50%" />
                      <thead className="job-card-title">
                        <tr>
                          <th colSpan={2} className="p-[6px]">
                            Denominations
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetails.denominations?.map((elm, index) => (
                          <tr key={`${index}-${elm.denomination}`}>
                            <td className="title">
                              {elm.denomination}-{elm.shape}
                            </td>
                            <td className="value">{elm.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </TabsContent>
                </Tabs>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
